import React, { useEffect, useRef, useState } from 'react';
import { Col, Row } from 'antd';
import { SectionLayout } from 'components/Sections/SectionLayout';
import FeaturedContent from './FeaturedContent';
import Text from 'components/Core/Text';
import CopyContainer from './CopyContainer';
import getBreakpointView from 'utils/getBreakpointView';
import MobileFeatures from './MobileFeatures';

import { DesktopContainer } from './styles';

const InPageFeaturesV4 = ({ cta, reversed, title, inPageNavigationItems, index }) => {
  const containerRef = useRef();
  const [intervalId, setIntervalId] = useState();
  let [slideInfo, setSlideInfo] = useState({ timer: 0, index: 0, completedOnce: false });
  const [slideshowStarted, setSlideshowStarted] = useState(false);
  const [inViewport, setInViewport] = useState(false);
  const isMobile = getBreakpointView(['xs', 'sm']);

  const updateSlideshowInfo = () => {
    setSlideInfo(({ timer, index, completedOnce }) => {
      let newValue = {
        timer: timer + 1,
        index,
        completedOnce,
      };
      if (newValue.timer === 105) {
        if (index !== inPageNavigationItems.length - 1) {
          newValue = {
            timer: 0,
            index: index + 1,
            completedOnce: true,
          };
        } else {
          newValue = {
            timer: 0,
            index: 0,
            completedOnce,
          };
        }
      }
      return newValue;
    });
  };

  useEffect(() => {
    if (!isMobile) {
      const observer = new IntersectionObserver(entry => {
        if (entry[0].isIntersecting) {
          setInViewport(true);
        } else {
          stopSlideshow();
        }
      });

      observer.observe(containerRef.current);
    }
  }, [containerRef, isMobile]);

  useEffect(() => {
    if (!isMobile && inViewport) {
      startSlideshow();
      setSlideshowStarted(true);
    } else if (isMobile) {
      stopSlideshow();
    }
  }, [isMobile, inViewport]);

  const handleItemClick = index => {
    clearInterval(intervalId);
    setSlideInfo({ timer: 0, index, completedOnce: true });
  };

  const handleCopyHover = hovering => {
    if (hovering) {
      stopSlideshow();
      setSlideInfo(({ timer, index, completedOnce }) => {
        return { timer: timer - 3, index, completedOnce };
      });
    } else {
      startSlideshow();
    }
  };

  const startSlideshow = () => {
    const interval = setInterval(updateSlideshowInfo, 75);
    setIntervalId(interval);
  };

  const stopSlideshow = () => {
    clearInterval(intervalId);
    setSlideshowStarted(false);
  };

  return (
    <SectionLayout>
      {title && (
        <Text type="h2" alignMobile="center" marginMobile="0 0 40px 0">
          {title}
        </Text>
      )}
      {!isMobile ? (
        <DesktopContainer ref={containerRef} reversed={reversed}>
          <Row gutter={60}>
            <Col xs={13} className="in-page-features-v4--featured-content">
              <FeaturedContent slideInfo={slideInfo} items={inPageNavigationItems} />
            </Col>
            <Col xs={11}>
              <CopyContainer
                slideInfo={slideInfo}
                slideshowStarted={slideshowStarted}
                handleCopyHover={handleCopyHover}
                handleItemClick={handleItemClick}
                items={inPageNavigationItems}
                index={index}
                callToAction={cta}
              />
            </Col>
          </Row>
        </DesktopContainer>
      ) : (
        <MobileFeatures items={inPageNavigationItems} callToAction={cta} />
      )}
    </SectionLayout>
  );
};

export default InPageFeaturesV4;
